import { render, staticRenderFns } from "./VarianceIcon.vue?vue&type=template&id=3783390e&scoped=true&"
import script from "./VarianceIcon.vue?vue&type=script&lang=ts&"
export * from "./VarianceIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3783390e",
  null
  
)

export default component.exports